export class GetMyGroupsAction {
  static readonly type = '[MyGroups] GetMyGroupsAction';
}
